"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("components");
var styles = __importStar(require("./Fee.module.css"));
var Fee = (function (_super) {
    __extends(Fee, _super);
    function Fee(props) {
        return _super.call(this, props) || this;
    }
    Fee.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, model = _a.model, _b = _a.fee, title = _b.title, identifier = _b.identifier, placeholder = _b.placeholder, description = _b.description;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees }, title),
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees },
                react_1.default.createElement(components_1.Input, { id: identifier, json_data: json_data, onChange: onChange, errors: errors, placeholder: placeholder, disabled: true })),
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees }, description)));
    };
    return Fee;
}(react_1.Component));
exports.default = Fee;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmVlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9OdXJzaW5nRW5yb2xsbWVudFBhY2tldC9wYXJ0cy9TZWN0aW9uNy9GZWUvRmVlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLHlDQUFnQztBQUNoQyx1REFBMEM7QUFVMUM7SUFBaUMsdUJBQW9CO0lBQ2pELGFBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBRUQsb0JBQU0sR0FBTjtRQUNVLElBQUEsZUFNUSxFQUxWLHdCQUFTLEVBQ1Qsc0JBQVEsRUFDUixrQkFBTSxFQUNOLGdCQUFLLEVBQ0wsV0FBa0QsRUFBNUMsZ0JBQUssRUFBRSwwQkFBVSxFQUFFLDRCQUFXLEVBQUUsNEJBQzVCLENBQUE7UUFFZCxPQUFPLENBQ0gsOEJBQUMsZUFBSyxDQUFDLFFBQVE7WUFDWCxzQ0FBSSxLQUFLLEVBQUMsS0FBSyxFQUFDLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FBUyxJQUN0QyxLQUFLLENBQ0w7WUFDTCxzQ0FBSSxLQUFLLEVBQUMsS0FBSyxFQUFDLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FBUztnQkFDdkMsOEJBQUMsa0JBQUssSUFDRixFQUFFLEVBQUUsVUFBVSxFQUNkLFNBQVMsRUFBRSxTQUFTLEVBQ3BCLFFBQVEsRUFBRSxRQUFRLEVBQ2xCLE1BQU0sRUFBRSxNQUFNLEVBQ2QsV0FBVyxFQUFFLFdBQVcsRUFDeEIsUUFBUSxFQUFFLElBQUksR0FDaEIsQ0FDRDtZQUNMLHNDQUFJLEtBQUssRUFBQyxLQUFLLEVBQUMsU0FBUyxFQUFFLE1BQU0sQ0FBQyxTQUFTLElBQ3RDLFdBQVcsQ0FDWCxDQUNRLENBQ3BCLENBQUE7SUFDTCxDQUFDO0lBQ0wsVUFBQztBQUFELENBQUMsQUFuQ0QsQ0FBaUMsaUJBQVMsR0FtQ3pDIn0=